import * as api from 'config/axios';
import * as endpoints from './endpoints';

export const getHelpContentAllFields = () => {
  return api.sendGet(endpoints.HELP_CONTENT_ALL_FIELDS);
};

export const addHelpContentField = (params) => {
  return api.sendPost(endpoints.HELP_CONTENT_ADD_FIELD, params);
};

export const editHelpContentField = (params) => {
  return api.sendPost(endpoints.HELP_CONTENT_EDIT_FIELD, params);
};

export const getHelpContentGridFields = (params) => {
  return api.sendGet(endpoints.HELP_CONTENT_GRID_FIELDS, { params });
};

export const getHelpContentTooltipMember = (params) => {
  return api.sendGet(endpoints.HELP_CONTENT_GET_TOOLTIP_MEMBER, { params });
};
